import React, { useState, useRef, useEffect } from 'react';
import styles from "./Dropdown.module.scss";
import { FaChevronDown } from "react-icons/fa";
import { FaChevronUp } from "react-icons/fa";
import { CheckIcon } from '../../../../../../views/pages/manage/masters/studentFinancials/paymentCollection/manage-receipts/CheckIcon';
import { useWizard } from '../../../../../../components/wizard/WizardContext';
import { getStepsByRefundType } from '../../../config';
import { refundTypes } from '../../../config';



const RefundTypeDropdown = () => {

    const {setStepsConfig, updateValues, values} = useWizard();
    const {refundType} = values;

    const [isOpen, setIsOpen] = useState(false);
    // const [selected, setSelected] = useState(refundTypes[0]);

      const dropdownRef = useRef(null);

      const handleRefundTypeChange = type => {
        updateValues("refundType", type);
        setStepsConfig(getStepsByRefundType(type?.value));
      }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


    return (
        <div ref={dropdownRef} className={styles['container'] + " mr-2"}>

            <div className={'d-flex justify-content-between align-items-center ' + styles['toggler']} onClick={() => setIsOpen(prev => !prev)}>
                <span className={styles['type-label']}>Type</span>
                <span className={styles['selected-label']}>{refundType?.label}</span>
                {isOpen ? <FaChevronUp /> : <FaChevronDown />}
            </div>

            {isOpen &&
                <div className={"d-flex flex-column " + styles['dropdown']}>
                    {
                        refundTypes?.map(type => {
                            const { value, label, description } = type;
                            const isSelected = refundType?.value === value;

                            return (
                                <div className={styles['dropdown-item']} onClick={() => handleRefundTypeChange(type)} key={value}>

                                    <div className={styles['label'] + " " + (isSelected && styles['color-blue'])}>
                                        {label}
                                        {isSelected && <span className='ml-2'><CheckIcon color='#00B0F5' /></span>}
                                    </div>

                                    <div className={styles['description']}>{description}</div>

                                </div>
                            )
                        })
                    }
                </div>
            }

        </div>
    );
}

export default RefundTypeDropdown;